var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { pxToRem } from '../../utils';
var hoverFocusStyle = function (variables) { return ({
    background: variables.selectableFocusHoverBackgroundColor,
    color: variables.selectableFocusHoverColor,
    cursor: 'pointer',
    '& .ui-item-layout__header': { color: 'inherit' },
    '& .ui-item-layout__content': { color: 'inherit' },
    // hide the header media and content media on hover
    '& .ui-item-layout__headerMedia': { display: 'none', color: 'inherit' },
    '& .ui-item-layout__contentMedia': { display: 'none', color: 'inherit' },
    // show the end media on hover
    '& .ui-item-layout__endMedia': { display: 'block', color: 'inherit' },
}); };
var selectedStyle = function (variables) { return ({
    background: variables.selectedBackgroundColor,
    color: variables.selectedColor,
}); };
var listItemStyles = {
    root: function (_a) {
        var _b = _a.props, selectable = _b.selectable, selected = _b.selected, important = _b.important, variables = _a.variables;
        return (__assign({}, (selectable && __assign({ position: 'relative', 
            // hide the end media by default
            '& .ui-item-layout__endMedia': { display: 'none' }, '&:hover': hoverFocusStyle(variables), '&:focus': hoverFocusStyle(variables) }, (selected && selectedStyle(variables)))), (important && {
            fontWeight: 'bold',
        })));
    },
    media: function (_a) {
        var props = _a.props;
        var important = props.important;
        return __assign({}, (important && {
            '::before': {
                content: '""',
                position: 'absolute',
                left: pxToRem(8),
                width: pxToRem(2),
                height: pxToRem(2),
                background: '#000',
            },
        }));
    },
    header: function (_a) {
        var variables = _a.variables;
        return ({
            fontSize: variables.headerFontSize,
            lineHeight: variables.headerLineHeight,
        });
    },
    headerMedia: function (_a) {
        var variables = _a.variables;
        return ({
            fontSize: variables.headerMediaFontSize,
            lineHeight: variables.headerMediaLineHeight,
        });
    },
    content: function (_a) {
        var variables = _a.variables;
        return ({
            fontSize: variables.contentFontSize,
            lineHeight: variables.contentLineHeight,
        });
    },
};
export default listItemStyles;
